"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InfoAndBenefits = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));
var _sanitizeHtml = _interopRequireDefault(require("sanitize-html"));
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const InfoAndBenefits = ({
  benefits,
  info
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  if (!info && benefits.length < 1) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    "data-testid": getTestId(_constants.INFO_AND_BENEFITS),
    children: [info == null ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
      color: "textPrimary",
      component: "div",
      "data-testid": getTestId(_constants.INFO),
      children: (0, _htmlReactParser.default)((0, _sanitizeHtml.default)(info))
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
      component: "div",
      fontWeight: "bold",
      children: benefits.map(benefit => /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Benefit, {
        "data-testid": getTestId(_constants.BENEFIT),
        children: (0, _htmlReactParser.default)((0, _sanitizeHtml.default)(benefit))
      }, benefit))
    })]
  });
};
exports.InfoAndBenefits = InfoAndBenefits;
//# sourceMappingURL=InfoAndBenefits.js.map